const removeParticipant = (state, action) => {
  switch (action.status) {
    case 'started':
      return {
        ...state,
        removingParticipant: true,
      };
    case 'success':
    case 'error':
      return {
        ...state,
        removingParticipant: false,
      };
    default:
      return state;
  }
};

export default removeParticipant;
